module.exports = __webpack_public_path__ + "01152b5001c9d395e26fe1d3d2496b60.png";